import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

const isDebugMode = process.env.NODE_ENV === 'development'

export type SupportedLanguage = 'en' | 'de'
export const fallbackLanguage: SupportedLanguage = 'en'
export const supportedLanguages: SupportedLanguage[] = ['en', 'de']

export type LanguageOption = {
  name: string
  code: SupportedLanguage
}

export const languageOptions: LanguageOption[] = [
  { name: 'Deutsch', code: 'de' },
  { name: 'English', code: 'en' },
]

export const namespaces = [
  'attachment',
  'backendMessages',
  'buyerSettings',
  'common',
  'components',
  'deliveryForecast',
  'deliveryForecastDespatchAdvice',
  'deliveryForecasts',
  'deliveryForecastsHistory',
  'despatchAdvice',
  'einvoice_rulesets',
  'eInvoiceCockpit',
  'eInvoiceDetails',
  'eInvoiceHistory',
  'eInvoiceOverview',
  'errors',
  'fallbackRender',
  'footer',
  'glossary',
  'invoice',
  'keyboardshortcuts',
  'login',
  'maintenance',
  'masterDataManagement',
  'members',
  'notFound',
  'orders',
  'ordersHistory',
  'orderResponse',
  'primelocale',
  'roleAssignments',
  'settings',
  'sidebar',
  'supplier',
  'suppliers',
  'tenant',
  'trial',
  'unitCode',
]

const initOptions = {
  debug: isDebugMode,
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    allowMultiLoading: true,
  },
  supportedLngs: supportedLanguages,
  fallbackLng: fallbackLanguage,
  ns: namespaces,
  preload: supportedLanguages,
  defaultNS: 'common',
  nsSeparator: '.',
  interpolation: {
    escapeValue: false,
  },
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(initOptions)

export default i18n
